import { render, staticRenderFns } from "./HeaderLogoSvg.vue?vue&type=template&id=b3688228&"
import script from "./HeaderLogoSvg.vue?vue&type=script&lang=js&"
export * from "./HeaderLogoSvg.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports